import { useStore } from "vuex";

function getOpenIds(categoryID, array) {
  for (let i = 0; i < array.length; i += 1) {
    if (array[i].categoryID === categoryID) {
      return [array[i].categoryID];
    }
    if (array[i].hasSubCategories) {
      const result = getOpenIds(categoryID, array[i].children);
      if (result) {
        return [array[i].categoryID].concat(result);
      }
    }
  }
  return null;
}

async function initSiteNavigator(store) {
  await store.dispatch("api/fetchCategoryTree");
}

async function updateSiteNavigator(store, params) {
  if (params && params.categoryID) {
    const siteNavigatorInfo = await store.dispatch("api/fetchCategoryTree");
    const openIds = getOpenIds(params.categoryID, siteNavigatorInfo);
    await store.dispatch("setSiteNavigatorVar", {
      key: "openIDs",
      value: openIds,
    });
  }
}

export default function useSiteNavigator() {
  const store = useStore();

  return {
    initSiteNavigator: () => initSiteNavigator(store),
    updateSiteNavigator: (params) => updateSiteNavigator(store, params),
  };
}

/*
  We still need to use the site navigator function in some plain JS files
  (namely the Vuex store functions). Once these are refactored to Pinia
  we can make this a pure composable.
*/
export { initSiteNavigator, updateSiteNavigator };
